const Logger = require("../Logger");
const Utils = require("../Utils");
const ConfigurationFactory = require("../ConfigurationFactory");
const PlaylistItemInfo = require("../Info/PlaylistItemInfo");
const PresentationParser = require("../Parser/PresentationParser");
const ViewerDataInfo = require("../Data/ViewerDataInfo");
const TimelineParser = require("../Parser/TimelineParser");
const TimerController = require("./TimerController");
const PlaylistItemController = require("./PlaylistItemController");
const WidgetController = require("./WidgetController");
const GadgetController = require("./GadgetController");
const PlaceholderVideoController = require("./PlaceholderVideoController");
const VideoController = require("./VideoController");

function PlaceholderController(placeholder, presFrame, htmlName,
  onPlaceholderReady, onPlaceholderDone) {
  const factory = {};

  const GADGET_WRAPPER_SCRIPT = `<script>try {
      updateGadgetWrapper('%s1', '%s2', %s3, %s4, '%s5');
      } catch(err) { parent.writeToLog('updateGadgetWrapper call - %s2 - ' + err.message); }
      </script>`;

  let status;

  const gadgets = [];

  const thirdPartyWidgets = [
    "7ea455e6-1e42-4eb8-91ab-818eb6b699b2", // computer aid countdown
    "4290722c-e15c-441e-a243-887dad864ce7", // computer aid countup
    "cf8a8c03-4461-4a9e-8a56-1254384d3b25", // computer aid mostly sunny
    "d5198c5e-c3a1-4156-b468-001c9f9ab040", // computer aid photo feed
    "e8fdec6f-bcfb-4102-a91f-77ddc79b73c9", // computer aid ticky
    "5e2ba915-a206-48c9-b398-1f6755663c08", // computer aid traffic map
    "40e35d3d-ed16-4226-b7df-898e717a799d", // digichief news
    "bfa04e64-4eeb-4fcf-9a1b-2a741ce95126", // digichief sports
    "684ff886-f83d-4e95-9b56-5864c5ec0de5", // digichief forecast
    "9e8fb866-0f21-485d-8f68-7529c48ca9d4", // digichief maps
    "5dba4bee-b26d-4592-9f22-a7b46b1bd693", // smartplayds facebook
    "007b8e54-074e-40cc-9a27-6d35f56b4df9", // flight time tv arrivals
    "9af58096-ab67-406b-bb39-6297556651e1", // flight time tv departures
    "17d1c54e-3c56-45f9-ad76-8f7458def71f", // scotts vimeo
    "03c02e24-80ad-42b3-8e10-7f6e716228aa"  // scotts youtube
  ]


  let videoController;

  let currentItem = -1, nextItem = -1, lastItem = -1;
  let doneReceived = false;

  const timerController = TimerController.getInstance();
  let itemTime = -1;
  let scheduleTime = -1;

  let isPlaying = false;

  factory.init = () => {
    status = PlaylistItemInfo.UNLOADED_STATUS;

    _bindPlaylist();
  };

  let _bindPlaylist = () => {
    // Removes items with blank durations
    let count = 0;

    if (placeholder && placeholder.items) {
      for (let i = 0; i < placeholder.items.length; i++) {
        const item = placeholder.items[i];
        const validDuration = (!(item.duration < 1) || item.playUntilDone);
        const thirdPartyWidget = thirdPartyWidgets.includes(item.objectReference);
        const validDistribution = item.distributeToAll || ConfigurationFactory.checkDistribution(item.distribution);

        if (validDuration && !thirdPartyWidget && validDistribution) {
          let gadgetName = htmlName + "_" + count;

          // add first letter of Gadget type to the name
          if (item.type && item.type.length > 1) {
            gadgetName = gadgetName + item.type.substring(0, 1);
          }

          let gadget;
          if (item && item.type === PlaylistItemInfo.TYPE_VIDEO) {
            if (videoController == null) {
              videoController = new PlaceholderVideoController(placeholder, presFrame, htmlName);
            }
            gadget = new VideoController(item, gadgetName, _onGadgetReady, _onGadgetDone, videoController);
          }
          else if (item && item.type === PlaylistItemInfo.TYPE_GADGET) {
            gadget = new GadgetController(placeholder, item, htmlName, gadgetName, _onGadgetReady, _onGadgetDone);
          }
          else if (item && item.type === PlaylistItemInfo.TYPE_WIDGET) {
            gadget = new WidgetController(placeholder, item, htmlName, gadgetName, _onGadgetReady, _onGadgetDone);
          }
          else {
            gadget = new PlaylistItemController(placeholder, item, htmlName, gadgetName, _onGadgetReady, _onGadgetDone);
          }

          if ((ConfigurationFactory.isDisplay() || ConfigurationFactory.isWebPlayer()) && item) {
            if (item.type === PlaylistItemInfo.TYPE_GADGET) {
              Logger.logExternalMessage("gadget used", item.objectReference);
              Logger.recordUptimeHeartbeat({
                eventApp: "Gadget: " + gadgetName + " ID: " + item.objectReference,
                eventAppVersion: "N/A" // version should not be empty
              });
            } else if (item.type === PlaylistItemInfo.TYPE_WIDGET) {
              Logger.logExternalMessage("widget used", item.objectReference);
              Logger.recordUptimeHeartbeat({
                eventApp: "Widget: " + gadgetName + " ID: " + item.objectReference,
                eventAppVersion: "N/A" // version should not be empty
              });
            } else {
              Logger.logExternalMessage(item.type + " item used", "");
              Logger.recordUptimeHeartbeat({
                eventApp: "Item: " + gadgetName + " ID: " + item.objectReference,
                eventAppVersion: "N/A" // version should not be empty
              });
            }
         }

          gadgets.push(gadget);
          count++;
        } else {
          WidgetController.sendReadyToPlayer(item.objectData);
        }
      }
    }

    if (gadgets.length === 0) {
      _onGadgetReady();
    }
  };

  factory.updateHtml = (presentation) => {
    if (gadgets.length !== 0) {
      // load placeholder as hidden (show only if empty)
      PresentationParser.hidePlaceholder(presentation, placeholder.id);

      _addGadgetWrapper(presentation, placeholder.id, htmlName,
          0, 0,
          placeholder.transition);

      for (let i = 0; i < gadgets.length; i++) {
        gadgets[i].updateHtml(presentation);
      }

      if (videoController) {
        videoController.updateHtml(presentation);
      }
    } else if (placeholder.visibility === false) {
      // hide empty non visible placeholders
      PresentationParser.hidePlaceholder(presentation, placeholder.id);
    }
  };

  let _addGadgetWrapper = (presentation, containerName, htmlName, width, height, transition) => {
    const modifiedGadgetScript = GADGET_WRAPPER_SCRIPT.replace(/%s1/g, containerName)
            .replace(/%s2/g, htmlName)
            .replace(/%s3/g, width)
            .replace(/%s4/g, height)
            .replace(/%s5/g, transition);

    PresentationParser.addScriptTag(presentation, modifiedGadgetScript);
  };

  let _onGadgetReady = () => {
    if (status !== PlaylistItemInfo.READY_STATUS) {
      status = PlaylistItemInfo.READY_STATUS;
      onPlaceholderReady();
    }

    // if lastItem == -1 then we haven't played through any
    if (isPlaying && lastItem === -1 && gadgets.length > 0) {
      if (currentItem !== -1 && gadgets[currentItem].isReady()) {
        _showPlaceholder(true);

        gadgets[currentItem].play(true);
        lastItem = currentItem;
      } else if (currentItem === -1) {
        _playNextItem(true);
      }
    }
  };

  let _onGadgetDone = () => {
    if (doneReceived) {
      Logger.logDebug(`Placeholder ${ConfigurationFactory.isEmbed() ? "(Embedded) " : ""}- Done received multiple times!`);

      gadgets[currentItem].stop(true);

      // Will trigger next item playback
      currentItem = -1;
    } else {
      doneReceived = true;
    }

    if (isPlaying && currentItem !== -1 && !gadgets[currentItem].getItem().playUntilDone &&
      lastItem === currentItem) {
      gadgets[currentItem].stop(false);
      gadgets[currentItem].play(false);
    }
    else {
      // Next item should play - reset doneReceived
      doneReceived = false;

      _playNextItem(true);
    }

    // Reset doneReceived once play has executed
    // to prevent recursion loop
    doneReceived = false;
  };

  const _timerExecute = () => {
    if (itemTime !== -1) {
      itemTime--;
    }

    // calculate the next item time
    if (itemTime === 0) {
      _playNextItem(true);
    }

    if (scheduleTime !== -1) {
      scheduleTime--;
    }

    if (scheduleTime === 0) {
      if (gadgets.length === 0) {
        _playEmptyPlaceholder();
      } else {
        _verifySchedule(true);
      }
    }
  };

  const _setNextItemCheck = (seconds) => {
    itemTime = seconds;
  };

  const _setNextScheduleCheck = (seconds) => {
    scheduleTime = seconds;
  };

  factory.play = () => {
    Logger.setEndpointLoggerContentFields({placeholderId: placeholder.id});
    if (placeholder.visibility !== false && !isPlaying) {
      if (gadgets.length === 0 && TimelineParser.applies()) {
        _playEmptyPlaceholder();
      } else if (/* status == READY_STATUS && */ gadgets.length > 0) {
        if (TimelineParser.applies()) {
          _verifySchedule(false);
        } else {
          isPlaying = true;
          _playNextItem(false);
        }
      }
    }

    // returning false calls presentationDone
    return !onPlaceholderDone || gadgets.length === 0 || isPlaying ||
      placeholder.visibility === false;
  };

  let _playEmptyPlaceholder = () => {
    if (TimelineParser.canPlay(placeholder)) {
      if (!isPlaying) {
        isPlaying = true;
        _showPlaceholder(true);
      }
    } else {
      if (isPlaying) {
        factory.stop();
      }
      _showPlaceholder(false);
    }

    _setNextScheduleCheck(60 - new Date().getSeconds());
  };

  let _verifySchedule = (executeDoneCommand) => {
    _setNextScheduleCheck(60 - new Date().getSeconds());

    if (TimelineParser.canPlay(placeholder)) {
      if (!isPlaying) {
        isPlaying = true;
        _playNextItem(executeDoneCommand);
      } else if (currentItem !== -1 && !TimelineParser.canPlay(gadgets[currentItem].getItem())) {
        _playNextItem(executeDoneCommand);
      }
    } else if (onPlaceholderDone && executeDoneCommand) {
      onPlaceholderDone();
    } else {
      if (isPlaying) {
        factory.stop();
      }
      _showPlaceholder(false);
    }
  };

  let _playNextItem = (executeDoneCommand) => {
    // Reset any previous timers
    _setNextItemCheck(-1);

    // only send Done if an item actually played
    if (onPlaceholderDone && nextItem === gadgets.length - 1) {
      nextItem = -1;
      isPlaying = false;

      if (executeDoneCommand && lastItem !== -1) {
        Logger.logDebug(`Placeholder ${ConfigurationFactory.isEmbed() ? "(Embedded) " : ""}- executeDoneCommand!`);

        onPlaceholderDone();
      } else if (lastItem === -1 && currentItem !== -1) {
        gadgets[currentItem].stop(true);

        // we haven't played through any items yet
        currentItem = -1;
      }

      return;
    }

    // signifies Done was sent right after Play
    if (isPlaying && lastItem !== currentItem && currentItem !== -1 && gadgets[currentItem].isReady()) {
      Logger.logDebug(`Placeholder ${ConfigurationFactory.isEmbed() ? "(Embedded) " : ""}- Done after play Stop!`);

      gadgets[currentItem].stop(true);

      // we haven't played through any items yet
      if (lastItem === -1) {
        currentItem = -1;
      } else if (nextItem === gadgets.length - 1) {
        // Stop the last item just in case before clearing reference
        gadgets[lastItem].stop(true);

        lastItem = -1;
      }
    }

    _setNextItem();

    if (nextItem === -1) {
      Logger.logDebug(`Placeholder ${ConfigurationFactory.isEmbed() ? "(Embedded) " : ""}- end of playback stop!`);

      // This will stop playback; stop the last item just in case
      if (lastItem !== -1) {
        gadgets[lastItem].stop(true);
        lastItem = -1;
      }

      _setNextItemCheck(60 - new Date().getSeconds());

      _showPlaceholder(false);
    } else if (!TimelineParser.canPlay(gadgets[nextItem].getItem())) {
      if (nextItem === currentItem) {
        currentItem = -1;
      }

      _playNextItem(executeDoneCommand);
    } else if (!gadgets[nextItem].isReady() && gadgets[nextItem].getItem().playUntilDone) {
      // if the item is PUD but not ready, skip it
      _playNextItem(executeDoneCommand);
    } else if (!gadgets[nextItem].isReady()) {
      if (gadgets.length !== 1) {
        // Continue playing current item for next item duration
        const duration = gadgets[nextItem].getItem().duration;
        _setNextItemCheck(duration);
      }

      currentItem = nextItem;
    } else {
      _showPlaceholder(true);
      currentItem = nextItem;

      if (!gadgets[currentItem].getItem().playUntilDone) {
        const duration = gadgets[currentItem].getItem().duration;
          // Schedule the timer to run once in x seconds.
        _setNextItemCheck(duration);
      }

      Logger.logDebug(`Placeholder ${htmlName} ${ConfigurationFactory.isEmbed() ? "(Embedded) " : ""}- Counters before - last:${lastItem} current:${currentItem} next:${nextItem}`);

      gadgets[currentItem].play(true);

      if (lastItem !== -1 && currentItem !== lastItem) {
        gadgets[lastItem].pause(true);
      }

      Logger.logDebug(`Placeholder ${htmlName} ${ConfigurationFactory.isEmbed() ? "(Embedded) " : ""}- Counters after - last:${lastItem} current:${currentItem} next:${nextItem}`);

      lastItem = currentItem;
    }
  };

  let _setNextItem = () => {
    if (nextItem < gadgets.length - 1) {
      nextItem++;
    } else if (currentItem !== -1) {
      nextItem = 0;
    } else {
      nextItem = -1;
    }
  };

  factory.stop = () => {
    Logger.logDebug(`Placeholder ${ConfigurationFactory.isEmbed() ? "(Embedded) " : ""}- Stop!`);

    isPlaying = false;

    _setNextItemCheck(-1);
    _setNextScheduleCheck(-1);

    if (currentItem !== -1) {
      gadgets[currentItem].stop(true);

      // [AD] Prevent done next time the placeholder is played
      if (nextItem === gadgets.length - 1) {
        nextItem = -1;
      }
    }
  };

  factory.pause = () => {
    Logger.logDebug(`Placeholder ${ConfigurationFactory.isEmbed() ? "(Embedded) " : ""}- Pause!`);

    isPlaying = false;

    _setNextItemCheck(-1);
    _setNextScheduleCheck(-1);

    if (currentItem !== -1) {
      // AD: Added hide = true so pause can be called between presentations switching
      gadgets[currentItem].pause(true);

      // [AD] Prevent done next time the placeholder is played
      if (nextItem === gadgets.length - 1) {
        nextItem = -1;
      }
    }
  };

  factory.getStatus = () => {
    return status;
  };

  let _showPlaceholder = (show) => {
    Utils.showFrameElement(presFrame, placeholder.id, show);
  };

  factory.unload = () => {
    for (let i = 0; i < gadgets.length; i++) {
      gadgets[i].unload();
    }

    status = PlaylistItemInfo.UNLOADED_STATUS;
  };

  (function () {
    timerController.addTimerCommand(_timerExecute);
  }());

  return factory;
}

PlaceholderController.sendReadyToPlayerAllItems = (placeholder) => {
  placeholder.items.forEach((item) => {
    if (item.type === PlaylistItemInfo.TYPE_WIDGET) {
      WidgetController.sendReadyToPlayer(item.objectData);
    } else if (item.type === PlaylistItemInfo.TYPE_PRESENTATION) {
      const presentation = ViewerDataInfo.getPresentation(item.objectData);
      PresentationParser.parsePresentation(presentation);
      presentation.placeholders.forEach(PlaceholderController.sendReadyToPlayerAllItems);
    }
  });
};

module.exports = PlaceholderController;
